import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/modern-theme.css';
import './styles/toast.css';
import './styles/SplashScreen.css';
import AppTest from './AppTest';
import { ToastProvider } from './utils/toastContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ToastProvider>
    <AppTest />
  </ToastProvider>
);
